export const FABRIC_LOADING = 'FABRIC_LOADING';
export const FABRIC_FULFILLED = 'FABRIC_FULFILLED';
export const FABRICS_FULFILLED = 'FABRICS_FULFILLED';
